import Link from "next/link";
import { Icon } from "@aqar-app/react-ui";
import { useQuery } from "@apollo/client";

import CardContainer from "../../components/cardContainer/cardContainer";
import SEO from "../../components/seo";
import { STATIC_PAGES_META } from "../../lib/metaDataHelpers";
import { InitialResolver } from "@/lib/use.middlewares";
import { GET_EJAR_CONTRACTS_TYPES } from "../../graphql/queries/sov";
import { financialFormat } from "../../lib/helpers";
import styles from "./ejarContracts.module.scss";
import {
  dehydrateApolloClient,
  initApolloClient,
} from "../../lib/apolloClient";

function EjarContracts() {
  const { data } = useQuery(GET_EJAR_CONTRACTS_TYPES);
  const contractTypes = data?.Offices?.Ejar?.getFees || [];

  return (
    <>
      <SEO {...STATIC_PAGES_META.ejarContracts} />
      <CardContainer title="عقود الإيجار" cardClassName={styles.cardContainer}>
        <div className={styles.container}>
          <div className={styles.noteContainer}>
            <Icon
              name="contracts"
              width={150}
              height={150}
              className={styles.headerIcon}
              alt="ejarContracts"
            />
            <span className={styles.note}>
              تمكنك هذه الخدمة من توثيق عقود الإيجار من خلال منصة إيجار سواء
              العقود السكنية أو التجارية
            </span>
          </div>
          <hr className={styles.breakLine} />
          <div className={styles.content}>
            <h4 className={styles.title}>الرجاء اختيار نوع العقد</h4>
            <div className={styles.contractList}>
              {contractTypes.map((contract) => (
                <Link
                  className={styles.contract}
                  href={`/عقود-الإيجار/${contract.type_id}`}
                >
                  {contract.type_id === 14 ? (
                    <Icon name="ejar-residential" width={36} height={36} />
                  ) : (
                    <Icon name="ejar-commercial" width={36} height={36} />
                  )}
                  <div>
                    <h4>{contract.name}</h4>
                    <p>
                      {contract.value
                        ? financialFormat(contract.value, "ريال")
                        : ""}
                    </p>
                  </div>
                  <Icon width={25} height={25} name="leftArrow-searches" />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </CardContainer>
    </>
  );
}

EjarContracts.getInitialProps = InitialResolver(async (ctx, $res) => {
  const apolloClient = initApolloClient();
  await apolloClient.query({
    query: GET_EJAR_CONTRACTS_TYPES,
  });
  return $res(dehydrateApolloClient(apolloClient, {}));
});
export default EjarContracts;
